import React, { PureComponent } from 'react';
import Changelog from '../../components/Changelog/Changelog';
import { changelog } from './changelog';

import styles from './ChangelogPage.scss'

export default class ChangelogPage extends PureComponent {
  render() {
    return (
      <main role="main" id="developer-portal-changelog-page" className={styles['changelog-page']}>
        <div className="body-wrap">
          <div className="rec-nested-wrap">
            <div className={`body-section ${styles['body-section']}`}>
              <h2>RIDB Changelog</h2>
              <Changelog changelog={changelog} />
            </div>
          </div>
        </div>
      </main>
    )
  }
}
